import { render, staticRenderFns } from "./menu_section.vue?vue&type=template&id=17538823"
import script from "./menu_section.vue?vue&type=script&lang=js"
export * from "./menu_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports